import { EBasicField } from 'src/app/project/shared/enums/basic-fields-enums';
import { EStatus } from 'src/app/project/shared/enums/status.enum';
import {
  TSearchFilter,
  TSearchFilterRow,
} from '../../filters-advanced/models/advanced-filter.model';
import { EPointSearchOperator } from '../../points/point-search/point-search.consts';
import { EPriority } from '../../points/priorities';

export function getDefaultQuickFilters(): TSearchFilter[] {
  const statusFilter: TSearchFilterRow = {
    keys: [EBasicField.STATUS.toLowerCase()],
    operator: EPointSearchOperator.IN,
    values: [EStatus.OPEN, EStatus.IN_PROGRESS, EStatus.TO_REVIEW, EStatus.ONHOLD],
  };

  const priorityFilter: TSearchFilterRow = {
    keys: [EBasicField.PRIORITY.toLowerCase()],
    operator: EPointSearchOperator.IN,
    values: [EPriority.HIGH, EPriority.MEDIUM, EPriority.LOW],
  };

  return [statusFilter, priorityFilter];
}
